import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    standalone: false
})
export class NotificationComponent {
  isSuccess: boolean = true;
  title: string = '';
  message: string = '';

  constructor(public dialogRef: DynamicDialogRef, private config: DynamicDialogConfig) {
    this.isSuccess = this.config.data?.isSuccess ?? true;
    this.title = this.config.data?.title ?? '';
    this.message = this.config.data?.message ?? '';
  }
}
